import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../services/auth.service';

function AuthCallback() {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const {setCurrentUser} = useAuth();
  const effectCalled = useRef(false);

  useEffect(() => {
    if(effectCalled.current) return;
    effectCalled.current = true;

    if(location.pathname!='/auth-callback') return;
    const queryParams = new URLSearchParams(window.location.search);
    const status = queryParams.get('status');
    console.log(queryParams.get('status'));
    if (status === "success") {
      const access_token = queryParams.get('access_token');
      const tokenType = queryParams.get('token_type');
      setCurrentUser({access_token: access_token, tokenType: tokenType});      
      navigate('/dashboard');
    } else if (status === "failure") {
      const detail = queryParams.get('detail');
      console.log(detail);
      console.error(detail);
      navigate(`/signin?error=${detail}`);
    }else {
      navigate('/')
    }
    setIsLoading(false);
  }, []);
  
  //Needs UI here
  return isLoading ? <div>Loading...</div> : null;
}

export default AuthCallback;